module.exports = __webpack_public_path__ + "img/11.b7e826b1.jpg";